/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import {Modal} from 'react-overlays';
import Button from '../common/Button';

const backdropStyle = {
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 3,
  backgroundColor: '#000',
  opacity: 0.5
};
const SessionModal = ({showExtendModal, extendSession, message}) => {

  return (
    <div className="extend-session-container">
      <Modal
        key="extend-session"
        className="extend-modal"
        backdropStyle={backdropStyle}
        show={showExtendModal}>
        <div className="extend-modal-dialog">
          <h4>Session Expiration
          </h4>
          <p id="session-extend-title">{message}</p>
          <br/>
          <form id="extend-session-container">
            <div className="extend-buttons">
              <span className="extend">
                <Button
                  value="OK"
                  disabled={false}
                  onClick={extendSession}
                  className="extend-session-btn"/>
              </span>

            </div>
          </form>
        </div>

      </Modal>
    </div>

  );
};
SessionModal.propTypes = {
  showExtendModal: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  extendSession: PropTypes.func.isRequired
};
export default SessionModal;



/** WEBPACK FOOTER **
 ** ./src/components/common/SessionModal.js
 **/